import { Br } from "@/components/molecules/Br";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import Contact from "@/components/organisms/Contact";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";
import Image from "next/image";
import Link from "next/link";
import CoverPri from "/public/cover-pri.webp";
import CoverSec from "/public/cover-sec.webp";
import IdentityLine from "/public/identity-line.svg";

export default function Identity(props) {
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={"経営理念"}
        pageDescription={
          "株式会社トッカシステムズの経営理念です。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/identity/philosophy"}
      />
      <Layout className="relative">
        <Header isRelative={isHeaderRelative} />
        <main className="z-10 flex-1">
          <Container>
            <Inner className="mx-auto box-border flex max-w-7xl flex-col py-10 px-6 text-pri sm:px-8 md:px-12 md:pt-16 md:pb-24 xl:px-0">
              <div className="relative mb-2 flex aspect-[9.9375/1] h-auto w-full items-center justify-center md:mb-0">
                <h4 className="relative z-10 text-center font-bold fluid-text-[13px,18px]">
                  私たちは、行動指針、および価値観・カルチャーを
                  <Br sp />
                  アイデンティティーとして定めています
                </h4>
                <div className="absolute top-0 left-0 z-0 aspect-[9.9375/1] h-auto w-full max-w-7xl">
                  <Image
                    src={IdentityLine}
                    alt="Identity"
                    quality={80}
                    layout="fill"
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2">
                <Link href="/identity/guidelines/">
                  <div className="relative col-span-1 cursor-pointer overflow-hidden p-12 transition-all hover:brightness-110 md:pt-60">
                    <div className="">
                      <div className="relative z-10 space-y-4 text-white">
                        <h3 className="font-serif font-bold fluid-text-[22px,32px]">
                          行動指針
                        </h3>
                        <div className="fluid-text-[12px,18px]">
                          私たちは、より良い顧客価値を創造するために、
                          <Br pc />
                          当社の定める行動指針に基づいて、行動および判断をします
                        </div>
                      </div>
                      <div className="absolute top-1/2 left-1/2 z-0 aspect-[3.415/1] h-[424px] w-auto -translate-x-1/2 -translate-y-1/2">
                        <Image src={CoverPri} quality={80} layout="fill" />
                      </div>
                    </div>
                  </div>
                </Link>
                <Link href="/identity/culture/">
                  <div className="col-span- relative cursor-pointer overflow-hidden p-12 transition-all hover:brightness-110 md:pt-60">
                    <div className="">
                      <div className="relative z-10 space-y-4 text-white">
                        <h3 className="font-serif font-bold fluid-text-[22px,32px]">
                          価値観・カルチャー
                        </h3>
                        <div className="fluid-text-[12px,18px]">
                          私たちは、事業を推進していくため、仲間とともに充実した
                          <Br pc />
                          職業人生を歩んでいくための価値観・カルチャーを共有します
                        </div>
                      </div>
                      <div className="absolute top-1/2 left-1/2 z-0 aspect-[3.415/1] h-[424px] w-auto -translate-x-1/2 -translate-y-1/2">
                        <Image src={CoverSec} quality={80} layout="fill" />
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </Inner>
          </Container>
        </main>
        <Contact>
          ご応募や採用に関するお問い合わせ／ご連絡をお待ちしております。
          <br />
          まずはお気軽にお問い合わせください。
        </Contact>
        <Footer />
      </Layout>
    </>
  );
}
